export default __webpack_public_path__ + "static/media/logo.c828f60a.png";